<style lang="stylus">
.add-courses {
  background: url('../assets/icons/bg_image.png') center / cover no-repeat;

  // background-position-y: -155px;
  p {
    color: black;
  }

  select {
    background-color: white;
  }

  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 56px;
  }
}

.v-overlay__content {
  max-height: 80vh !important;
}

.search-results {
  color: rgb(40, 149, 188);
  font-weight: 600;
}

.closeButton {
  background-color: black;
  border-radius: 2px;
  color: white;
  padding: 5px 22px;
  height: 56px;
  margin: 5px 0 0 4px;
}

.course-warning-head-modal {
  background-color: #fec627;
  font-size: 24px;
  font-weight: bold !important;
}

.course-warning-message {
  font-size: 16px;
  font-weight: 400;
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.course-warning-goback-button {
  font-size: 18px;
  border: 2px solid #2a2a2a;
  border-radius: 100px;
  font-weight: bold;
  padding: 5.7px 16px;
}

.filter-course-button {
  background-color: #fec627;
  border-radius: 50px;
  padding: 14px 24px;
  font-weight: bold;
  margin: 2px 0px 20px 0px;
}

// Override v-col padding for filter dropdowns
.filter-col {
  padding: 4px !important;
}

.course-warning-buttons {
  text-align: end;
  padding: 16px;
}

.warning-yes-button {
  height: 42px !important;
  background-color: #fec627 !important;
  font-weight: bold !important;
  border-radius: 100px !important;
  margin-bottom: 10px !important;
  font-size: 18px !important;
}

@media only screen and (min-width: 1024px) {
  .selected-courses {
    height: 100%;
  }
}

@media only screen and (max-width: 379px) {
  .course-warning-buttons {
    text-align: start;
  }

  .course-warning-goback-button {
    margin-bottom: 16px;
  }

  .warning-yes-button {
    margin: 0 0 16px 0 !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  // for iPad and iPad Pro
  // .add-courses {
  // background-position-y: -382px;
  // }
}

.course-search {
  width: 180px;
  font-weight: 500;
  background: #191919;
  color: #fff;
}

.sticky-section {
  top: 10px !important;
  position: sticky !important;
}

.course-search-header {
  font-weight: 400;
  margin: 0 0 0 5px;
  font-size: 16px;
  color: #fff !important;
  padding: 1em 0em;
}

.v-input__icon.v-input__icon--append {
  align-items: end;
}

.tab-footer-view {
  @media (min-width: 750px) and (max-width: 900px) {
    padding-bottom: 6%;
  }
}
</style>

<template>
  <div v-if="isUserAuthenticated">
    <div
      class="add-courses"
      :style="{
        'background-color': courses.length > 0 ? 'rgba(0, 0, 0, 0.06)' : ''
      }"
    >
      <v-container class="container">
        <v-row>
          <v-col cols="12" class="mt-10">
            <div class="courseLabel course-search">Course Search</div>
          </v-col>
          <v-col cols="12">
            <p class="course-search-header">Search our course catalog or view all available courses below.</p>
          </v-col>
          <v-col cols="12" md="7" sm="6" class="pl-1">
            <v-text-field v-model="searchTerm" id="searchTerm" label="Keyword" variant="solo" />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <button class="filter-course-button" @click="displayFilterOptions = !displayFilterOptions">
              <!-- <v-icon color="white">far fa-search fa-1.5x</v-icon> -->
              {{ displayFilterOptions ? 'Hide Filters' : 'Show Filters' }}
              <span style="padding: 0px 5px"><img alt="filter" src="../assets/icons/filter icon.svg" /></span>
            </button>
            <!-- <i class="far fa-sliders-h" style="margin-left:10px; color:white; font-size:28px;"></i> -->
          </v-col>
          <!-- <v-col md3 sm2></v-col> -->
          <v-row no-gutters style="margin-bottom: 14px; margin-left: 10px" v-if="displayFilterOptions">
            <v-col
              cols="6"
              sm="2"
              md="2"
              @click="asuoDataLayerClick('AddCourses', '0', '', { text: 'Session', type: 'dropdown', action: 'open' })"
              class="filter-col"
            >
              <v-select
                class="filter-dropdown"
                bg-color="white"
                variant="solo"
                :items="degreePaths"
                label="Session"
                v-model="selectedDegreePath"
                :menu-props="{ scrollStrategy: 'close' }"
                @update:modelValue="
                  asuoDataLayerClick('AddCourses', '0', '', {
                    text: selectedDegreePath,
                    type: 'Session',
                    action: 'click'
                  })
                "
              />
            </v-col>
            <v-col cols="6" sm="2" md="2" class="filter-col">
              <v-select
                class="filter-dropdown"
                bg-color="white"
                variant="solo"
                :items="InterestArea"
                v-model="selectedInterestArea"
                label="Interest Area"
                :menu-props="{ scrollStrategy: 'close' }"
              />
            </v-col>

            <v-col cols="6" sm="2" md="2" class="filter-col">
              <v-autocomplete
                class="filter-dropdown"
                :items="sortedCreditDesignations"
                v-model="selectedCreditDesignation"
                variant="solo"
                label="Credit Designation"
                multiple
                bg-color="white"
                :menu-props="{ scrollStrategy: 'close' }"
              >
                <template v-slot:selection="slotData">
                  <div v-if="slotData.index === 0">{{ selectedCreditDesignation.length || 0 }} Selected</div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="6" sm="2" md="2" class="filter-col">
              <v-select
                class="filter-dropdown"
                bg-color="white"
                variant="solo"
                :items="degreeLength"
                label="Length"
                v-model="selectedDegreeLength"
                :menu-props="{ scrollStrategy: 'close' }"
              />
            </v-col>
            <v-col cols="6" sm="2" md="2" class="filter-col">
              <v-select
                class="filter-dropdown"
                bg-color="white"
                variant="solo"
                :items="NoOfCredits"
                label="Credits"
                v-model="SelectedNoOfCredits"
                :menu-props="{ scrollStrategy: 'close' }"
              />
            </v-col>
          </v-row>
        </v-row>
      </v-container>
      <v-container />
    </div>
    <v-container class="container">
      <v-row style="margin-top: 40px; justify-content: space-around">
        <v-col cols="12" md="8" lg="9" xl="9">
          <v-row>
            <p
              v-if="coursesInitialized"
              class="search-results"
              style="margin: 8px 0px 20px; color: #747474; font-size: 21px"
            >
              Your Search Returned {{ filteredCoursesCount }} Results
            </p>
            <!-- Individual Course -->
            <v-col cols="12" style="height: 60vh" v-if="courses.length === 0 && coursesInitialized">
              <v-row>
                <v-col cols="12" sm="12" md="12" />
                <v-col class="pa-0" cols="12" sm="4" md="12">
                  <p style="font-weight: 500">
                    {{ noCourseMsg }}
                    <a href="mailto:ulcourses@asu.edu" style="color: #8c1d40; text-decoration: underline"
                      >ulcourses@asu.edu</a
                    >.
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <my-courses
                v-for="(course, index) in filteredCourses"
                v-bind:key="
                  course._courseName +
                  course._courseStartDate +
                  ' ' +
                  course._isSelected +
                  ' ' +
                  course._courseOfferingId
                "
                :courseIndex="index"
                :title="course._courseName"
                :coursePrefix="course._coursePrefix"
                :coursePrefixDisplayLabel="course._coursePrefixDisplayLabel"
                :buttonAction="course._buttonAction"
                :buttonLabel="course._buttonLabel"
                :courseStartDate="course._courseStartDate"
                :eaCourseURL="course._eaCourseURL"
                :courseEndDate="course._courseEndDate"
                :creditConvertedDate="course._creditConvertedDate"
                :transcriptedDate="course._transcriptedDate"
                :credits="course._asuCredits"
                :term="course._term"
                :courseDescription="course._courseDescription"
                :button="course._button"
                :benefitsEligible="course._benefitsEligible"
                :partnerBenefitEligible="course._partnerBenefitEligible"
                :courseType="course._courseType"
                :from="'add-courses'"
                :grade="0"
                :finalGrade="''"
                :selected="course._isSelected"
                :courseOfferingId="course._courseOfferingId"
                :courseSelected="course._isCourseSelected"
                :isPathwayCourse="course._isPathwayCourse"
                :creditConverted="course._creditConverted"
                :LMS="course._LMS"
                :canvasCourseId="course._canvasCourseId"
                :canvasUserId="course._canvasUserId"
                :coursePrerequisite="course._coursePrerequisite"
                :isNonEnrollableCourse="course._isNonEnrollableCourse"
                :courseLength="course._courseLength"
                :coursePrerequisiteLabel="course._coursePrerequisiteLabel"
                :courseEffortPerHour="course._courseEffortPerHour"
                :coursePacing="course._coursePacing"
                :courseDesignations="course._courseDesignations"
                v-on:addCourse="addCourse($event)"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3" xl="3">
          <v-row row class="selected-courses">
            <v-col cols="12" style="margin-top: 50px !important">
              <div class="sticky-section" style="width: 330px">
                <selected-courses
                  @isMoreThanTwoSessionBasedCoursesSelected="isMoreThanTwoSessionBasedCoursesSelected()"
                  :selectedCourses="selectedCourses"
                  :allCourses="courses"
                  v-on:addCourse="addCourse($event)"
                  :style="checkCourseAdded && reachedBottom ? 'z-index: 1; top: 150px' : 'top: 10px'"
                  style="transition: all 0.5s ease 0s"
                  :shouldShowNote="shouldShowNote"
                />
                <!-- <college-courses> -->
                <college-courses
                  :style="reachedBottom ? 'z-index: 0' : ''"
                  v-scroll="onScroll"
                  top="0"
                  :scroll-y="checkEnrollmentSectionHeight"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" max-width="720">
      <v-card>
        <v-card-title class="headline course-warning-head-modal" style="padding-left: 24px; padding-right: 24px">
          Yikes!
          <br />You’re about to add more than the recommended course load
          <v-icon @click="dialog = false" style="position: absolute; right: 16px; top: 12px; font-size: 23"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="course-warning-message">
          We recommend a maximum course load of 2 courses per session so you have adequate time to complete your
          assignments.
          <br />
        </v-card-text>
        <v-card-text class="course-warning-message" style="padding-top: 10px"
          >Are you sure you’d like to continue?</v-card-text
        >
        <div class="course-warning-buttons">
          <button @click="dialog = false" class="course-warning-goback-button">No, go back</button>
          <v-btn class="warning-yes-button" color="#fec627" :ripple="false" variant="flat" @click="next()" rounded
            >Yes, add all courses</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <div v-if="showLargeScreenDialog()">
      <v-dialog v-model="blockAccessToEnrollCourse" width="800" class="dialogClass">
        <v-card style="text-align: center; background-color: white">
          <v-col class="pa-4">
            <v-col
              cols="12"
              style="height: 50px; margin-bottom: 18px; cursor: pointer"
              @click="closeBlockStudentDialog()"
            >
              <v-icon style="float: right; color: black; margin-top: 24px"> mdi-close </v-icon>
            </v-col>
            <v-col style="text-align: start">
              <p
                v-if="blockAdmittedStudentToEnrollCourse"
                style="font-weight: 800; font-size: 36px; margin-bottom: 32px"
              >
                Universal Learner Courses Unavailable
              </p>
              <p
                v-else-if="blockDisqualifiedStudentToEnrollCourse"
                style="font-weight: 800; font-size: 36px; margin-bottom: 32px"
              >
                Course Access Suspended
              </p>
            </v-col>
            <v-col
              v-if="blockAdmittedStudentToEnrollCourse"
              cols="12"
              style="text-align: left; letter-spacing: -0.2px; line-height: 1.5"
            >
              Universal Learner Courses (ULCs) are specifically designed as a pathway for learners who hope to one day
              attend ASU, but they are not available to current degree-seeking ASU students.
              <v-spacer style="height: 20px" />
              As an admitted ASU student, you have access to a wide range of ASU courses and resources designed to help
              you succeed. Please refer to the
              <a
                href="https://catalog.apps.asu.edu/catalog/classes"
                style="color: black; text-decoration: underline"
                target="_blank"
                >ASU Course Catalog</a
              >
              for available courses.
            </v-col>
            <v-col
              v-else-if="blockDisqualifiedStudentToEnrollCourse"
              cols="12"
              style="text-align: left; letter-spacing: -0.2px; line-height: 1.5"
            >
              Your access to Universal Learner Courses has been temporarily suspended due to a violation of the
              <a
                style="color: #8c1d40; text-decoration: underline"
                href="https://docs.google.com/document/d/1pr6nAIQuyp9AzCfeNiXxMoICXI3rksn18scSm5jHMWk/edit"
                target="_blank"
                >Learner Code of Conduct</a
              >
              or
              <a
                style="color: #8c1d40; text-decoration: underline"
                href="https://webapp4.asu.edu/myasu/"
                target="_blank"
                >academic hold</a
              >. If you have questions about this policy or your access, please contact our Support Team at
              <a style="color: #8c1d40; text-decoration: underline" target="_blank" href="tel:844-448-7707"
                >844-448-7707</a
              >
              or
              <a href="mailto:ulcourses@asu.edu" style="color: #8c1d40; text-decoration: underline" target="_blank"
                >ulcourses@asu.edu</a
              >.
            </v-col>
            <v-spacer style="height: 20px" />

            <v-col cols="12" class="closeDialog justify-end" style="display: flex">
              <v-btn
                :style="blockDisqualifiedStudentToEnrollCourse ? 'margin-left:auto' : ''"
                style="
                  background-color: #fec627;
                  color: black !important;
                  z-index: 999;
                  border-radius: 20px;
                  box-shadow: none;
                "
                @click="redirectedPage()"
                >Return to Dashboard</v-btn
              >

              <v-btn
                v-if="blockAdmittedStudentToEnrollCourse"
                style="
                  background-color: #8c1d40;
                  color: white !important;
                  z-index: 999;
                  border-radius: 20px;
                  box-shadow: none;
                "
                @click="redirectToCatalogPage()"
                >View ASU Course Catalog</v-btn
              >
            </v-col>
            <v-spacer style="height: 30px" />
          </v-col>
        </v-card>
      </v-dialog>
    </div>

    <div v-else>
      <v-dialog v-model="blockAccessToEnrollCourse" width="800" class="dialogClass">
        <v-card style="text-align: center; background-color: white">
          <v-col style="margin: 0px 24px">
            <v-col
              cols="12"
              style="height: 50px; margin-bottom: 18px; cursor: pointer"
              @click="closeBlockStudentDialog()"
            >
              <v-icon style="float: right; color: black; margin-top: 24px"> mdi-close </v-icon>
            </v-col>
            <v-col cols="12" style="text-align: left">
              Universal Learner Courses (ULCs) are specifically designed as a pathway for learners who hope to one day
              attend ASU, but they are not available to current degree-seeking ASU students.
              <v-spacer style="height: 25px" />
              As an admitted ASU student, you have access to a wide range of ASU courses and resources designed to help
              you succeed. Please refer to the
              <a
                href="https://catalog.apps.asu.edu/catalog/classes"
                style="color: black; text-decoration: underline"
                target="_blank"
                >ASU Course Catalog</a
              >
              for available courses. We apologize for the inconvenience.
            </v-col>
            <v-spacer style="height: 30px" />
          </v-col>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore, useCoursesStore } from '@/stores';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { SessionInitializer } from '../mixins/sessionInitializer';
import { Logger } from '../mixins/logger';
import { Helper } from '../mixins/helpers.js';
import CanvasModel from '../data_models/canvas_user.model';

export default defineComponent({
  name: 'addCourses',

  data() {
    return {
      isUserAuthenticated: false,
      earnedCredits: 0,
      totalCredits: 0,
      currentGPA: '0.0',
      selectedDegreePath: null,
      searchTerm: '',
      selectedCourses: [],
      courses: [],
      degreePaths: [],
      dialog: false,
      lastClickedCourse: '',
      noCourseMsg: '',
      degreeLength: ['Any', '8 Weeks', '12 Weeks', '16 Weeks', 'On-demand'],
      selectedDegreeLength: null,
      NoOfCredits: ['Any', '2 Credits', '3 Credits', '4 Credits'],
      SelectedNoOfCredits: null,
      displayFilterOptions: true,
      InterestArea: [],
      CreditDesignations: [],
      selectedInterestArea: null,
      selectedCreditDesignation: [],
      totalSelectedCourses: 0,
      enrollments: null,
      shouldDisplayText: false,
      checkEnrollmentSectionHeight: 0,
      reachedBottom: false,
      selectedCoursePrefixes: [],
      blockAdmittedStudentToEnrollCourse: false,
      blockDisqualifiedStudentToEnrollCourse: false,
      coursesInitialized: false,
      loadingError: null
    };
  },

  mixins: [DataLayerMixin, AjaxLoader, SessionInitializer, Logger, Helper],

  props: {
    degreePath: {
      type: String
    },
    refreshDashboardPage: {
      type: Object
    },
    data: {
      type: Object
    }
  },

  watch: {
    selectedCourses: {
      deep: true,

      handler: function () {
        if (
          document.getElementsByClassName('enrollment-section').length &&
          this.checkEnrollmentSectionHeight <
            parseInt(window.getComputedStyle(document.getElementsByClassName('enrollment-section')[0], null).height) +
              250
        ) {
          this.removeTop();
        } else {
          this.addTop();
        }
      }
    },
    'refreshDashboardPage.dashboard'() {
      // Force refresh when dashboard prop changes (for view-as functionality)
      this.getEnrollmentsAndCourses((enrollments) => {
        this.logInfo('get enrollments and courses', enrollments);
      });

      // Also refresh course catalog data for new user
      this.initializeCoursesData();
    }
  },

  mounted() {
    if (this.degreePath) {
      this.selectedDegreePath = this.degreePath;
    }

    this.addTop();
  },

  computed: {
    blockAccessToEnrollCourse() {
      return this.blockDisqualifiedStudentToEnrollCourse || this.blockAdmittedStudentToEnrollCourse;
    },

    shouldShowNote() {
      return ['3', '4'].includes(this.$conn.learnerData._benefitType);
    },

    checkCourseAdded() {
      return this.selectedCourses.length == 0 ? false : true;
    },

    filteredCourses() {
      const filtered = this.courses.filter((e) => {
        const isDegreePathSelected =
          !this.selectedDegreePath ||
          this.selectedDegreePath === 'Any' ||
          (e._sessionName || '').includes(this.selectedDegreePath);
        const title = (e._courseName || '').toLowerCase();
        const prefix = (e._coursePrefix || '').toLowerCase();
        const prefixNoSpace = prefix.replace(/\s+/g, '');
        const combined = `${title} ${prefix}`.toLowerCase();
        const combinedNoSpace = `${title} ${prefixNoSpace}`.toLowerCase();
        const searchTokens = this.searchTerm
          .split(',')
          .map((token) => token.trim().toLowerCase())
          .filter((token) => token.length > 0);

        const keywordMatch =
          searchTokens.length === 0 ||
          searchTokens.some((token) => combined.includes(token) || combinedNoSpace.includes(token.replace(/\s+/g, '')));

        const chooseMultipleOrSingleSearch = keywordMatch;

        const isSelectedCredits =
          !this.SelectedNoOfCredits ||
          this.SelectedNoOfCredits === 'Any' ||
          (e._asuCredits.toString() || '').includes(this.SelectedNoOfCredits.split(' ')[0]);

        const isSelectedInterestArea =
          !this.selectedInterestArea ||
          this.selectedInterestArea === 'Any' ||
          (e._interestTrack || '').includes(this.selectedInterestArea);

        const isSelectedCreditDesignation =
          this.selectedCreditDesignation.length === 0 ||
          this.selectedCreditDesignation.includes('Any') ||
          this.creditDesignationFilter(e);

        // /4[A-C]$/g regex is for summer courses with terms C are also 8 weeks
        const term = (e._term || '').toLowerCase();
        const termOriginal = e._term || '';
        const selectedLength = this.selectedDegreeLength;

        const isSelectedDegreeLength =
          !selectedLength ||
          selectedLength === 'Any' ||
          (selectedLength.includes('Self Paced') && term.includes('self paced')) ||
          (selectedLength.includes('On-demand') && term.includes('on-demand')) ||
          (selectedLength.startsWith('8') &&
            (termOriginal.includes('A') || termOriginal.includes('B') || termOriginal.match(/4[A-C]$/g))) ||
          (selectedLength.startsWith('12') && termOriginal === '2254C') ||
          (selectedLength.startsWith('16') && termOriginal.includes('C') && !termOriginal.match(/4[A-C]$/g));

        return (
          isDegreePathSelected &&
          isSelectedCredits &&
          isSelectedInterestArea &&
          isSelectedDegreeLength &&
          isSelectedCreditDesignation &&
          chooseMultipleOrSingleSearch
        );
      });
      // NON-ENROLLABLE CHANGES - INTERCEPTING TO CHANGE THE BUTTON LABLE BASED ON NON-ENROLLABLE LIST
      const userStore = useUserStore();
      const nonEnrollableCourseList = userStore.apis.learnerData?._nonEnrollableCourseList || [];
      const nonEnrollableCoursePrefixList = nonEnrollableCourseList.map((course) => course.coursePrefix);
      filtered.forEach((course) => {
        if (nonEnrollableCoursePrefixList.includes(course._coursePrefix)) {
          course._buttonLabel = 'Transfer Credit';
          course._buttonAction = 'Transfer Credit';
          course._isNonEnrollableCourse = true;
          // course._isSelected = true;
        } else {
          course._isNonEnrollableCourse = false;
        }
      });
      return filtered;
    },
    sortedCreditDesignations() {
      // Deduplicate credit designations to prevent Vuetify ID conflicts
      const uniqueDesignations = [...new Set(this.CreditDesignations)];
      const anyOption = uniqueDesignations.find((opt) => opt === 'Any');
      const rest = uniqueDesignations.filter((opt) => opt !== 'Any').sort((a, b) => a.localeCompare(b));
      return anyOption ? [anyOption, ...rest] : rest;
    },

    filteredCoursesCount() {
      return this.filteredCourses.length;
    }
  },

  updated() {
    this.noCourseMsg =
      'Previous enrollment was covered by your high school partnership. If you wish to continue with Universal Learner Courses on your own, please contact';
  },

  methods: {
    closeBlockStudentDialog() {
      this.blockAdmittedStudentToEnrollCourse = false;
      this.blockDisqualifiedStudentToEnrollCourse = false;
      this.$router.push('/dashboard');
    },
    showLargeScreenDialog() {
      return this.$vuetify.display.mdAndUp;
    },
    redirectedPage() {
      this.$router.push('/dashboard');
    },
    redirectToCatalogPage() {
      window.open('https://catalog.apps.asu.edu/catalog/classes', '_blank');
    },
    creditDesignationFilter(course) {
      let matched = false;
      this.selectedCreditDesignation.forEach((e) => {
        course._courseDesignations.split('\r\n').forEach((credit) => {
          if (!credit.includes(':')) {
            credit = credit.replace(',', ':');
          }
          if (credit.includes(e)) {
            matched = true;
            return;
          }
        });
      });
      return matched;
    },
    onScroll() {
      if (window.innerHeight + window.scrollY >= document.documentElement.offsetHeight - 250) {
        this.reachedBottom = true;
      } else {
        this.reachedBottom = false;
      }
    },

    addTop() {
      let elem = document.getElementsByClassName('enrollment-section');

      if (elem.length)
        this.checkEnrollmentSectionHeight = parseInt(window.getComputedStyle(elem[0], null).height) + 250;
    },

    removeTop() {
      let elem = document.getElementsByClassName('enrollment-section');

      if (elem.length)
        this.checkEnrollmentSectionHeight = parseInt(window.getComputedStyle(elem[0], null).height) - 250;
    },

    addCourse(event) {
      this.lastClickedCourse = event.coursePrefix;

      this.courses = this.courses.map((e) => {
        if (
          e._coursePrefix === event.coursePrefix &&
          e._courseStartDate === event.courseStartDate &&
          e._courseOfferingId === event.courseOfferingId
        ) {
          e._isSelected = event.add;
        }

        return e;
      });
      this.refreshSelectedCourses();
      // this.isMoreThanTwoSessionBasedCoursesSelected();
    },

    refreshSelectedCourses() {
      const coursesStore = useCoursesStore();
      this.selectedCourses = this.courses.filter((e) => e._isSelected && !e._isCourseSelected);
      coursesStore.setSelectedCourses(this.selectedCourses);
    },

    isMoreThanTwoSessionBasedCoursesSelected() {
      let mapTermAndSelections = {};
      this.selectedCourses.forEach((e) => {
        if (e._term !== 'Self Paced') {
          // let term = e._term.endsWith('C') ? e._term.replace(/.$/, 'A') : e._term;
          let startDate = e._courseStartDate;

          if (mapTermAndSelections[startDate]) {
            mapTermAndSelections[startDate]++;
          } else {
            mapTermAndSelections[startDate] = 1;
          }
        }
      });

      for (let index = 0; index < Object.values(mapTermAndSelections).length; index++) {
        const element = Object.values(mapTermAndSelections)[index];

        if (element > 2) {
          this.totalSelectedCourses = element;
          this.dialog = true;
        }
      }
      if (this.dialog != true) {
        this.next();
      }
    },

    unselectCourseSelected() {
      this.courses = this.courses.map((e) => {
        if (this.lastClickedCourse === e._coursePrefix) e._isSelected = false;

        return e;
      });
      this.refreshSelectedCourses();
      this.dialog = false;
    },

    dummyLoader() {
      this.startLoading();

      setTimeout(() => {
        this.clearLoader();
      }, 500);
    },

    async next() {
      try {
        this.startLoading();

        let modifiedEnrollmentsList = this.courses.filter((elem) => elem._isSelected !== elem._isCourseSelected);

        this.logInfo('get enrollments for selected courses', modifiedEnrollmentsList);

        const enrollmentData = await this.$conn.refreshAndAddEnrollmentToSFForSelectedCourses(modifiedEnrollmentsList);

        this.logInfo('get enrollments for selected courses success', enrollmentData);

        this.$conn.enrollmentList.resetActiveInactiveEnrollments();
      } catch (error) {
        this.logError('get enrollments for selected courses failed', error);
      }
      // Show new course added message on accelerate dashboard
      const userStore = useUserStore();
      const query = Helper.methods.isAcceleratePartner(userStore.apis.learnerData?._partnerURLSubDomain)
        ? { newCourseAdded: true }
        : {};
      this.$router.push({ name: 'dashboard', query });

      this.clearLoader();
    },

    prepareCanvasBody(learner) {
      return new CanvasModel(learner);
    },

    getInterestTrack(courseList) {
      let arr = Array.from(new Set(courseList.reduce((a, b) => a + ';' + b._interestTrack, '').split(';')));

      const order = ['Business', 'Certificate Programs', 'Engineering', 'General Education', 'Nursing'];

      arr.sort((a, b) => {
        return order.indexOf(a) - order.indexOf(b);
      });

      return arr.filter((e) => !!e) || [];
    },

    getCreditDesignation(courseList) {
      let array = [];
      courseList.map((course) => {
        course._courseDesignations.split('\r\n').forEach((creditDesignation) => {
          //OS-5166 ref
          if (!creditDesignation.includes(':')) {
            creditDesignation = creditDesignation.replace(',', ':');
          }
          array.push(creditDesignation);
        });
      });

      // Remove duplicates and filter out empty values
      return [...new Set(array.filter((e) => !!e))];
    },

    getSessionNames(courseList) {
      // Extract unique session names from courses
      const sessionNames = courseList
        .map((course) => course._sessionName)
        .filter((sessionName) => !!sessionName && sessionName !== 'Any'); // Filter out null/undefined and 'Any'

      // Remove duplicates
      return [...new Set(sessionNames)];
    },

    /**
     * Mark catalog courses that align with the user's pathway
     * Checks both course prefixes and credit designations
     */
    async markPathwayCourses() {
      try {
        // Use lightweight endpoint to get pathway course prefixes and designations
        const pathwayData = await this.$conn.getPathwayCoursePrefixes();

        if (!pathwayData.enrolled) {
          return;
        }

        // Build sets for quick lookup
        const pathwayPrefixes = new Set(pathwayData.prefixes || []);
        const allDesignations = new Set([
          ...(pathwayData.designations?.required || []),
          ...(pathwayData.designations?.recommended || [])
        ]);

        // Helper to parse designation codes from string like "SCIT: Science\nHUAD: Humanities"
        const parseDesignationCodes = (designationString) => {
          if (!designationString || typeof designationString !== 'string') return [];
          return designationString
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line)
            .map((line) => {
              const colonIndex = line.indexOf(':');
              return colonIndex > 0 ? line.substring(0, colonIndex).trim() : line.trim();
            });
        };

        // Mark catalog courses that match pathway prefixes or designations
        this.courses.forEach((course) => {
          // Check if course prefix matches
          if (course._coursePrefix && pathwayPrefixes.has(course._coursePrefix)) {
            course._isPathwayCourse = true;
            return;
          }

          // Check if any course designation matches pathway designations
          const courseDesignationsRaw = course._courseDesignations || '';
          if (courseDesignationsRaw && allDesignations.size > 0) {
            const courseDesignationCodes = parseDesignationCodes(courseDesignationsRaw);
            const hasMatchingDesignation = courseDesignationCodes.some((d) => allDesignations.has(d));
            if (hasMatchingDesignation) {
              course._isPathwayCourse = true;
            }
          }
        });
      } catch (error) {
        this.logError('Failed to mark pathway courses', error);
      }
    },

    // Loading wrapper methods
    retryLoadingData() {
      this.loadingError = null;
      this.coursesInitialized = false;

      // Re-run the initialization
      this.init('addCourses', async () => {
        try {
          await this.initializeCoursesData();
        } catch (error) {
          this.loadingError = 'Failed to load courses. Please check your connection and try again.';
          this.logError('Failed to retry loading courses data', error);
        }
      });
    },

    goBackToDashboard() {
      this.$router.push('/dashboard');
    },

    async initializeCoursesData() {
      const userStore = useUserStore();
      const coursesStore = useCoursesStore();

      this.isUserAuthenticated = true;
      this.earnedCredits = this.$conn.learnerData.dashboardPageData.numberOfCreditsCompleted;
      this.totalCredits = this.$conn.learnerData.dashboardPageData.numberOfCreditsNeeded;
      this.currentGPA = parseFloat(this.$conn.learnerData.dashboardPageData.currentGPA).toFixed(1);

      // Check access permissions
      if (!userStore.apis?.learnerData?._allowAccessToAdmittedStudent) {
        this.startLoading();

        const response = await this.$conn.getBlockStatusForASUAdmittedStudent();
        this.blockAdmittedStudentToEnrollCourse = response?.response === 'Deny';
        this.clearLoader();

        if (this.blockAdmittedStudentToEnrollCourse) return;
      }

      if (!this.blockAdmittedStudentToEnrollCourse && userStore.apis?.learnerData?._disqualifyLearner) {
        this.blockDisqualifiedStudentToEnrollCourse = true;
        return;
      }

      const creditConvertedEnrollments = coursesStore.enrollments.filter((j) => {
        return j._creditConverted === 'Y';
      });

      this.logInfo(
        `creditConvertedEnrollments`,
        creditConvertedEnrollments.map((e) => e._courseInfo._coursePrefix).sort()
      );
      this.logInfo(
        `this.$conn.courseList._courses course prefixes`,
        this.$conn.courseList._courses.map((e) => e._coursePrefix).sort()
      );

      const isStarbucksPartner = ((this.$conn.learnerData || {})._partnerName || '')
        .toLowerCase()
        .includes('starbucks');

      // Process courses data
      this.courses = this.$conn.courseList._courses
        .filter((e) => {
          if (isStarbucksPartner && (e._coursePrefix || '').toLowerCase().replace(/\s/g, '') === 'ea11') {
            return false;
          } else if (!isStarbucksPartner) {
            return (e._coursePrefix || '').toLowerCase().replace(/\s/g, '') !== 'ea10';
          } else {
            return true;
          }
        })
        .map((e) => {
          const enrollment = this.$conn.enrollmentList.enrollments.filter((j) => {
            return j._courseOfferingId === e._courseOfferingId;
          })[0];

          e._benefitsEligible = enrollment ? enrollment._benefitsEligible : e._benefitsEligible;
          e._isSelected = e._isCourseSelected = enrollment ? enrollment._isCourseSelected : false;
          e._hideCourse = enrollment ? enrollment._hideCourse : false;
          e._creditConverted = enrollment ? enrollment._creditConverted : 'N';
          e._partnerBenefitEligible = this.$conn.learnerData._benefitType !== '4';
          e._creditConvertedDate = enrollment ? enrollment._creditConvertedDate : '';
          e._buttonAction = enrollment ? enrollment._buttonAction : '';
          e._buttonLabel = enrollment ? enrollment._buttonLabel : '';

          if (e._coursePrerequisite) {
            const prerequisiteCourse = this.$conn.enrollmentList.enrollments.filter((j) => {
              return (
                (j._courseCompletedDate || (j._creditEligible || '').toLowerCase() === 'y') &&
                ((j._courseInfo || {})._courseName === (e._coursePrerequisite || {}).courseName ||
                  (j._courseInfo || {})._coursePrefix === (e._coursePrerequisite || {}).coursePrefix ||
                  (j._courseInfo || {})._coursePrefixDisplayLabel ===
                    (e._coursePrerequisite || {}).coursePrefixDisplayLabel)
              );
            })[0];
            e._coursePrerequisite.courseCompletedDate = (prerequisiteCourse || {})._courseCompletedDate || '';
            e._coursePrerequisite.creditEligible = (prerequisiteCourse || {})._creditEligible || '';
          }

          let prefixAliases;
          if (e._coursePrefixAliases !== '') {
            prefixAliases = e._coursePrefixAliases.split(',');
            prefixAliases.push(e._coursePrefix);
          }

          // Override _creditConverted based on course prefix
          if (creditConvertedEnrollments.filter((i) => i._courseInfo._coursePrefix === e._coursePrefix).length > 0) {
            const creditConvertedEnrollment = creditConvertedEnrollments.filter(
              (i) => i._courseInfo._coursePrefix === e._coursePrefix
            )[0];
            e._creditConverted = 'Y';
            e._buttonLabel = creditConvertedEnrollment._buttonLabel;
            e._creditConvertedDate = creditConvertedEnrollment._creditConvertedDate;
            e._transcriptedDate = creditConvertedEnrollment._transcriptedDate;
          } else if (
            e._coursePrefixAliases !== '' &&
            prefixAliases.includes(e._coursePrefix) &&
            creditConvertedEnrollments.filter((i) => prefixAliases.includes(i._courseInfo._coursePrefix)).length > 0
          ) {
            const creditConvertedEnrollment = creditConvertedEnrollments.filter((i) =>
              prefixAliases.includes(i._courseInfo._coursePrefix)
            )[0];
            e._creditConverted = 'Y';
            e._buttonLabel = creditConvertedEnrollment._buttonLabel;
            e._creditConvertedDate = creditConvertedEnrollment._creditConvertedDate;
            e._transcriptedDate = creditConvertedEnrollment._transcriptedDate;
          } else if (enrollment) {
            e._creditConverted = enrollment._creditConverted;
          } else {
            e._creditConverted = 'N';
          }

          e._buttonLabel = e._buttonLabel === 'View Transcript' ? 'Transcripted' : e._buttonLabel;
          return e;
        })
        .filter((e) => !e._hideCourse);

      // Store prefixes on selected courses
      this.courses.forEach((e) => {
        if (e._isCourseSelected && e._coursePrefix !== null) {
          this.selectedCoursePrefixes.push({ coursePrefix: e._coursePrefix, courseOfferingId: e._courseOfferingId });
        }
      });

      // Change button label for similar course prefixes
      this.courses.map((e) => {
        this.selectedCoursePrefixes.forEach((f) => {
          if (e._coursePrefix == f.coursePrefix && e._courseOfferingId == f.courseOfferingId) {
            e._isSelected = e._isCourseSelected = true;
          }
        });
      });

      this.courses = this.courses.sort((a, b) => {
        if (a._coursePrefix < b._coursePrefix) return -1;
        if (a._coursePrefix > b._coursePrefix) return 1;
        return 0;
      });

      this.InterestArea = this.getInterestTrack(this.courses);
      this.InterestArea.unshift('Any');

      // Extract unique session names from courses and reset the array completely
      this.degreePaths = ['Any', ...this.getSessionNames(this.courses)];

      // Sort degree paths with desired order, self-paced at the end
      const desiredOrder = [
        'Any',
        'Fall A',
        'Fall C',
        'Fall B',
        'Spring A',
        'Spring C',
        'Spring B',
        'Summer A',
        'Summer C',
        'Summer B',
        'On-demand'
      ];

      this.degreePaths.sort((a, b) => {
        // 'Any' stays at the beginning
        if (a === 'Any') return -1;
        if (b === 'Any') return 1;

        // 'Self Paced' goes to the end
        if (a === 'Self Paced') return 1;
        if (b === 'Self Paced') return -1;

        // Sort by desired order
        const indexA = desiredOrder.findIndex((order) => a.startsWith(order));
        const indexB = desiredOrder.findIndex((order) => b.startsWith(order));

        // If both have order positions, sort by those
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        // Items with order positions come before items without
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        // Both don't have order positions, sort alphabetically
        return a.localeCompare(b);
      });

      this.CreditDesignations = this.getCreditDesignation(this.courses);
      this.CreditDesignations.unshift('Any');

      // Mark courses that align with user's pathway
      await this.markPathwayCourses();
      this.clearLoader();

      // Handle query parameters
      if (this.$route.query && this.$route.query.prefix) {
        this.addCourse({ coursePrefix: this.$route.query.prefix, add: true });
      }
      if (this.$route.query.searchCourse) {
        this.searchTerm = this.$route.query.searchCourse;
      }
      if (this.$route.query.searchDesignation) {
        let creditDesignationList = '';
        this.courses.forEach((e) => {
          (e._courseDesignations || '').split('\r\n').forEach((creditDesignation) => {
            if (!creditDesignation.includes(':')) {
              creditDesignation = creditDesignation.replace(',', ':');
            }
            if ((creditDesignation || '').split(':')[0] === this.$route.query.searchDesignation) {
              creditDesignationList = creditDesignation;
            }
          });
        });
        if (creditDesignationList) {
          this.selectedCreditDesignation.push(creditDesignationList);
        }
      }

      if (this.data) this.searchTerm = this.data.coursePrefix;
      this.coursesInitialized = true;
    }
  },

  created() {
    this.init('addCourses', async () => {
      try {
        await this.initializeCoursesData();
      } catch (error) {
        this.loadingError = 'Failed to load courses. Please check your connection and try again.';
        this.logError('Failed to initialize courses data', error);
      }
    });
  }
});
</script>
